import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {API_PATH} from '../../constants';
import {DamageImageModel, Question} from '../../models/underwriter.model';
import {DamageQuestionPasser} from '../../services/damage-question-passer';
import {GlobalQuestionService} from '../../services/global-question.service';

declare var $: any;

declare function notify(): any;

declare function initTooltips(): any;

@Component({
    selector: 'app-question-images-of-damage',
    templateUrl: './question-images-of-damage.component.html',
    styleUrls: ['./question-images-of-damage.component.scss'],
    standalone: false
})
export class QuestionImagesOfDamageComponent implements OnInit {

  @Input() question: Question;
  @Input() showNarrowCompletedItems = false;
  @Input() showSkip = true;
  @Input() showLabel = true;
  @Output() questionAnswer = new EventEmitter<any>();

  notify: any;
  initTooltips: any;
  incidentImages: any[] = [];
  modalDisableButton = true;
  tooltips: any = {};
  skipped = false;

  constructor(
    private damageImagePasser: DamageQuestionPasser,
    private globalQuestionService: GlobalQuestionService
  ) {
    this.notify = notify();
    this.damageImagePasser.updateComponent()
      .subscribe((damageImage: DamageImageModel) => {
        if (!damageImage || damageImage.sender === 'parent') {
          return;
        }
        this.addAreaDamage(damageImage);
        this.damageImagePasser.setDamageImageModal(false);
      });
  }

  updateTooltips(parameter: any): void {
    const underneathField = parameter.find((par: any) => par.parameter === 'tooltip_underneath');
    const underneath = underneathField?.value;
    const interiorField = parameter.find((par: any) => par.parameter === 'tooltip_interior');
    const interior = interiorField?.value;
    const windscreenField = parameter.find((par: any) => par.parameter === 'tooltip_windscreen');
    const windscreen = windscreenField?.value;
    const windowsField = parameter.find((par: any) => par.parameter === 'tooltip_windows');
    const windows = windowsField?.value;

    if (underneath) {
      this.tooltips.underneath = underneath;
    }

    if (interior) {
      this.tooltips.interior = interior;
    }

    if (windscreen) {
      this.tooltips.windscreen = windscreen;
    }

    if (windows) {
      this.tooltips.windows = windows;
    }
  }

  ngOnInit(): void {
    this.tooltips = {};
    let parameter: any;
    if (this.question.parameter) {
      parameter = JSON.parse(this.question.parameter);
      this.updateTooltips(parameter);
    }
    this.initTooltips = initTooltips();
    if (this.question?.answer?.length > 0) {
      try{
        const response = JSON.parse(this.question.answer);
        response.forEach((item: any) => {
          const incidentImage = {area: item.area, response: item.response, files: []};
          this.incidentImages.push(incidentImage);
          this.loadFilesForItem(incidentImage);
        });
      }
      catch(exception){
        //log error;
      }

    }
    this.updateCompletedSides();
  }

  loadFilesForItem(item: any): void {
    item.files = [];
    if (!item?.response) {
      return;
    }
    let parsedResponse: any;
    try {
      parsedResponse = JSON.parse(item.response);
    } catch (e) {
      return;
    }
    let resources: any[];
    try {
      resources = JSON.parse(parsedResponse?.resources);
    } catch (e) {
      return;
    }
    resources?.forEach((res: any) => {
      const resource_id = res?.resource_id;
      if (!resource_id) {
        return;
      }
      this.globalQuestionService.getUploadedFileDetails(resource_id)
        .subscribe((details: any) => {
          item.files.push({
            resource_id,
            name: details?.[0]?.original_filename,
            url: `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`
          });
        });
    });
  }

  removeUploadedFile(item: any, resource_id: string): void {
    this.globalQuestionService.removeFile(resource_id).subscribe(() => {
      item.files = item.files.filter((f: any) => f.resource_id !== resource_id);
      try {
        const parsedResponse = JSON.parse(item.response);
        const resources = (JSON.parse(parsedResponse?.resources) || []).filter((r: any) => r?.resource_id !== resource_id);
        parsedResponse.resources = JSON.stringify(resources);
        item.response = JSON.stringify(parsedResponse);
      } catch (e) { }
      this.updateCompletedSides();
    });
  }

  getSideResponse(response: string): any {
    return JSON.parse(response);
  }

  getResourcesLength(resources: string): any {
    const resourcesObject = JSON.parse(resources);
    if (!resourcesObject) {
      return 0;
    }
    return resourcesObject?.length;
  }

  changeText(area: string): void {
    
    const damageImageModel: DamageImageModel = {
      question: this.question,
      header_copy: `Show the <strong>damage</strong> caused to the <strong>${area} of the vehicle</strong>`,
      response: '',
      side: area,
      sender: 'parent',
      other_side_name: ''
    };
    if (area === 'other') {
      damageImageModel.header_copy = '<strong>Name</strong> and show the <strong>damage</strong> caused to that <strong>area</strong>';
    }
    const areaResponse = this.incidentImages.find((ii: any) => ii.area === area);
    if (areaResponse) {
      damageImageModel.response = areaResponse.response;
    }
    
    this.damageImagePasser.passDamageQuestion(damageImageModel);
    this.damageImagePasser.setDamageImageModal(true);
  }


  addAreaDamage(damageImage: DamageImageModel): void {
    if (damageImage.response.length === 0) {
      return;
    }
    const areaExists = this.incidentImages.some(o => o.area === damageImage.side);
    let changedItem: any;
    if (areaExists === false) {
      changedItem = {area: damageImage.side, response: damageImage.response, files: []};
      this.incidentImages.push(changedItem);
    } else {
      const foundIndex = this.incidentImages.findIndex(o => o.area === damageImage.side);
      this.incidentImages[foundIndex].response = damageImage.response;
      changedItem = this.incidentImages[foundIndex];
    }
    this.loadFilesForItem(changedItem);
    this.updateCompletedSides();
  }

  updateCompletedSides(): void {
    this.incidentImages.forEach((ii: any) => {
      if (ii.response.length > 0) {
        const side = ii.area;
        const selector = side.split(' ').join('-')?.toLowerCase();
        $(`.${selector}`).addClass('completed');
      }
    });
    if (this.incidentImages.length > 0) {
      this.question.answer = JSON.stringify(this.incidentImages.map((ii: any) => ({area: ii.area, response: ii.response})));
      this.questionAnswer.emit(this.question);
    }
  }

  onChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }

}
